import { getUploadUrl, setUploadComplete } from '../api/data-connectors/upload-files'
import { uploadFileToS3 } from '../api/s3/upload-file'
import { fileStatusService } from './file-status-service'
import { addLoadingFile, removeLoadingFile } from './loading-files-service'

// Singleton: uploads continue independently of component lifecycle, used for user uploaded files
class UploadService {
  // Fire-and-forget: automatically triggers status polling after upload
  async uploadFile(
    file: File,
    notify: (params: { isSuccess: boolean; text: string; position: 'top' | 'bottom' }) => void,
    t: (key: string, options?: Record<string, string>) => string
  ): Promise<void> {
    const fileKey = crypto.randomUUID()
    addLoadingFile(fileKey, file.name, file.type)

    try {
      const fileProperties = {
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
      }

      // Step 1: Get upload URL
      const { fileId, uploadUrl } = await getUploadUrl(fileProperties)

      // Step 2: Upload to S3
      await uploadFileToS3({ file, uploadUrl })

      // Step 3: Mark upload complete
      await setUploadComplete({ fileId })

      fileStatusService.startPolling(fileId, () => removeLoadingFile(fileKey), notify, t)
    } catch (error) {
      console.error(
        `File upload failed. File name: ${file.name}, file type: ${file.type}, file size: ${file.size}`,
        error
      )

      removeLoadingFile(fileKey)
      notify({
        isSuccess: false,
        text: t('files.uploadFailureToast', { filename: file.name }),
        position: 'bottom',
      })
    }
  }
}

export const uploadService = new UploadService()
